import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { itemCategoriesList, createItemCategories, editItemCategories, mobileItemCategoriesList, mobileCreateItemCategories, mobileEditItemCategories, mobileItemCategoriesDelete, getItemCategoriesDataByID, updateItemCategoriesStatus, itemCategoriesDelete } from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";

const namespace = "itemCategories";

// Async thunk for fetching the Portal User list
export const getItemCategoriesList = createAsyncThunk(
    `${namespace}/getItemCategoriesList`,
    async (
        { query = "", page = 1, limit = 10, sortby = "", order = "", id = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await itemCategoriesList(query, page, limit, sortby, order, id);
            return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for adding a Portal User
export const addItemCategories = createAsyncThunk(
    `${namespace}/addItemCategories`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await createItemCategories({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for updating Portal User data
export const updateItemCategories = createAsyncThunk(
    `${namespace}/UpdateItemCategories`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await editItemCategories({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const deleteItemCategories = createAsyncThunk(
    `${namespace}/itemCategoriesDelete`,
    async ({ deleteID }, { rejectWithValue, dispatch }) => {
        try {
            console.log(deleteID, "interdata");
            const data = await itemCategoriesDelete(deleteID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

//<------------------Mobile Item Categories Slice ------------------>//
// Async thunk for fetching the Portal User list
export const getMobileItemCategoriesList = createAsyncThunk(
    `${namespace}/getMobileItemCategoriesList`,
    async (
        { searchquery = "", page = 1, limit = 10, sortby = "", order = "", id = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await mobileItemCategoriesList(searchquery, page, limit, sortby, order, id);
            return JSON.parse(EncryptDecrypt.decryptdata(data.data.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for adding a Portal User
export const addMobileItemCategories = createAsyncThunk(
    `${namespace}/addMobileItemCategories`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await mobileCreateItemCategories({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for updating Portal User data
export const updateMobileItemCategories = createAsyncThunk(
    `${namespace}/updateMobileItemCategories`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            let payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await mobileEditItemCategories({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const deleteMobileItemCategories = createAsyncThunk(
    `${namespace}/deleteMobileItemCategories`,
    async ({ deleteID }, { rejectWithValue, dispatch }) => {
        try {
            console.log(deleteID, "interdata");
            const data = await mobileItemCategoriesDelete(deleteID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);


const itemCategories = createSlice({
    name: namespace,
    initialState: {
        itemCategoriesListData: [],
        mobileitemCategoriesListData: [],
        itemCategoriesListLoading: false,
        mobileitemCategoriesListLoading: false,
        addItemCategoriesLoading: false,
        mobileaddItemCategoriesLoading: false,
        addItemCategoriesSuccess: false,
        mobileaddItemCategoriesSuccess: false,
        addItemCategoriesError: false,
        mobileaddItemCategoriesError: false,
        addItemCategoriesErrorMessage: "",
        mobileaddItemCategoriesErrorMessage: "",
        updateItemCategoriesSuccess: false,
        mobileupdateItemCategoriesSuccess: false,
        updateItemCategoriesError: false,
        mobileupdateItemCategoriesError: false,
        updateItemCategoriesErrorMessage: "",
        mobileupdateItemCategoriesErrorMessage: "",
        deleteItemCategoriesLoading: false,
        mobiledeleteItemCategoriesLoading: false,
        deleteItemCategoriesSuccess: false,
        mobiledeleteItemCategoriesSuccess: false,
        deleteItemCategoriesError: false,
        mobiledeleteItemCategoriesError: false,
        deleteItemCategoriesErrorMessage: "",
        mobiledeleteItemCategoriesErrorMessage: "",
    },
    reducers: {
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // Handle getItemCategoriesList
            .addCase(getItemCategoriesList.pending, (state) => {
                state.itemCategoriesListLoading = true;
                state.addItemCategoriesLoading = false;
                state.addItemCategoriesSuccess = false;
                state.addItemCategoriesError = false;
                state.addItemCategoriesErrorMessage = "";
                state.updateItemCategoriesSuccess = false;
                state.updateItemCategoriesError = false;
                state.updateItemCategoriesErrorMessage = "";
                state.deleteItemCategoriesLoading = false;
                state.deleteItemCategoriesSuccess = false;
                state.deleteItemCategoriesError = false;
                state.deleteItemCategoriesErrorMessage = "";
            })
            .addCase(getItemCategoriesList.fulfilled, (state, action) => {
                const data = action.payload;
                state.itemCategoriesListData = data;
                state.itemCategoriesListLoading = false;
            })
            .addCase(getItemCategoriesList.rejected, (state) => {
                state.itemCategoriesListLoading = false;
            })

            // Handle add Item Categories
            .addCase(addItemCategories.pending, (state) => {
                state.addItemCategoriesLoading = true;
                state.addItemCategoriesError = false;
                state.addItemCategoriesSuccess = false;
            })
            .addCase(addItemCategories.fulfilled, (state, action) => {
                state.addItemCategoriesLoading = false;
                state.addItemCategoriesSuccess = true;
            })
            .addCase(addItemCategories.rejected, (state, action) => {
                const payload = action.payload.data;
                state.addItemCategoriesLoading = false;
                state.addItemCategoriesError = true;
                // state.addItemCategoriesErrorMessage = action.error.message;
                state.addItemCategoriesErrorMessage = "errors" in payload ? payload.errors[0].message : payload.message;
            })

            // Handle update Item Categories
            .addCase(updateItemCategories.pending, (state) => {
                state.updateItemCategoriesSuccess = false;
                state.updateItemCategoriesError = false;
                state.updateItemCategoriesErrorMessage = "";
            })
            .addCase(updateItemCategories.fulfilled, (state, action) => {
                state.updateItemCategoriesSuccess = true;
            })
            .addCase(updateItemCategories.rejected, (state, action) => {
                const payload = action.payload.data;
                state.updateItemCategoriesError = true;
                // state.updateItemCategoriesErrorMessage = action.error.message;
                state.updateItemCategoriesErrorMessage = "errors" in payload ? payload.errors[0].message : payload.message;
            })

            // Handle delete Item Categories
            .addCase(deleteItemCategories.pending, state => {
                state.deleteItemCategoriesLoading = true;
                state.deleteItemCategoriesError = false;
                state.deleteItemCategoriesSuccess = false;
                state.deleteItemCategoriesErrorMessage = "";
            })
            .addCase(deleteItemCategories.fulfilled, (state, action) => {
                state.deleteItemCategoriesSuccess = true;
                state.deleteItemCategoriesLoading = false;
            })
            .addCase(deleteItemCategories.rejected, (state, action) => {
                const payload = action.payload.data;
                state.deleteItemCategoriesError = true;
                state.deleteItemCategoriesLoading = false;
                // state.deleteItemCategoriesErrorMessage = action.error.message;
                state.deleteItemCategoriesErrorMessage = "errors" in payload ? payload.errors[0].message : payload.message;
            })

            //<------------------Mobile Item Categories Extra Reducers ------------------>//
            // Handle getMobileItemCategoriesList
            .addCase(getMobileItemCategoriesList.pending, (state) => {
                state.mobileitemCategoriesListLoading = true;
                state.mobileaddItemCategoriesLoading = false;
                state.mobileaddItemCategoriesSuccess = false;
                state.mobileaddItemCategoriesError = false;
                state.mobileaddItemCategoriesErrorMessage = "";
                state.mobileupdateItemCategoriesSuccess = false;
                state.mobileupdateItemCategoriesError = false;
                state.mobileupdateItemCategoriesErrorMessage = "";
                state.mobiledeleteItemCategoriesLoading = false;
                state.mobiledeleteItemCategoriesSuccess = false;
                state.mobiledeleteItemCategoriesError = false;
                state.mobiledeleteItemCategoriesErrorMessage = "";
            })
            .addCase(getMobileItemCategoriesList.fulfilled, (state, action) => {
                const data = action.payload;
                state.mobileitemCategoriesListData = data;
                state.mobileitemCategoriesListLoading = false;
            })
            .addCase(getMobileItemCategoriesList.rejected, (state) => {
                state.mobileitemCategoriesListLoading = false;
            })
            // Handle add Mobile Item Categories
            .addCase(addMobileItemCategories.pending, (state) => {
                state.mobileaddItemCategoriesLoading = true;
                state.mobileaddItemCategoriesError = false;
                state.mobileaddItemCategoriesSuccess = false;
            })
            .addCase(addMobileItemCategories.fulfilled, (state, action) => {
                state.mobileaddItemCategoriesLoading = false;
                state.mobileaddItemCategoriesSuccess = true;
            })
            .addCase(addMobileItemCategories.rejected, (state, action) => {
                const payload = action.payload.data;
                state.mobileaddItemCategoriesLoading = false;
                state.mobileaddItemCategoriesError = true;
                // state.mobileaddItemCategoriesErrorMessage = action.error.message;
                state.mobileaddItemCategoriesErrorMessage = "errors" in payload ? payload.errors[0].message : payload.message;
            })
            // Handle update Mobile Item Categories
            .addCase(updateMobileItemCategories.pending, (state) => {
                state.mobileupdateItemCategoriesSuccess = false;
                state.mobileupdateItemCategoriesError = false;
                state.mobileupdateItemCategoriesErrorMessage = "";
            })
            .addCase(updateMobileItemCategories.fulfilled, (state, action) => {
                state.mobileupdateItemCategoriesSuccess = true;
            })
            .addCase(updateMobileItemCategories.rejected, (state, action) => {
                const payload = action.payload.data;
                state.mobileupdateItemCategoriesError = true;
                // state.mobileupdateItemCategoriesErrorMessage = action.error.message;
                state.mobileupdateItemCategoriesErrorMessage = "errors" in payload ? payload.errors[0].message : payload.message;
            })
            // Handle delete Mobile Item Categories
            .addCase(deleteMobileItemCategories.pending, state => {
                state.mobiledeleteItemCategoriesLoading = true;
                state.mobiledeleteItemCategoriesError = false;
                state.mobiledeleteItemCategoriesSuccess = false;
                state.mobiledeleteItemCategoriesErrorMessage = "";
            })
            .addCase(deleteMobileItemCategories.fulfilled, (state, action) => {
                state.mobiledeleteItemCategoriesSuccess = true;
                state.mobiledeleteItemCategoriesLoading = false;
            })
            .addCase(deleteMobileItemCategories.rejected, (state, action) => {
                const payload = action.payload.data;
                state.mobiledeleteItemCategoriesError = true;
                state.mobiledeleteItemCategoriesLoading = false;
                // state.mobiledeleteItemCategoriesErrorMessage = action.error.message;
                state.mobiledeleteItemCategoriesErrorMessage = "errors" in payload ? payload.errors[0].message : payload.message;
            });
    },
});

export const { resetSuccessFlag } = itemCategories.actions;

export const itemCategoriesSelector = (state) => state[namespace];

export default itemCategories.reducer;
